// extracted by mini-css-extract-plugin
module.exports = {"arrow":"NavigationBarButton__arrow___1GAwK","triangle":"NavigationBarButton__triangle___2B23f","label":"NavigationBarButton__label___2Y6gC"};